<!-- Строки заказ-наряда ремонта и итоговые суммы. -->
<template>
  <BaseFormSection title="Работы и запчасти" icon="cargo">
    <div class="items-toolbar">
      <base-primary-button
        type="button"
        class="repair-add-item-button"
        @click="$emit('add-item')"
      >
        <AppIcon
          class="repair-add-item-button__icon"
          name="addSquare"
          :size="16"
        />
        Добавить
      </base-primary-button>

      <BaseActionLink
        :to="{
          name: 'CatalogItems',
          query: { 'q[usage_scope]': 'repair' },
        }"
      >
        Каталог
      </BaseActionLink>
    </div>

    <div class="repair-items-table">
      <div class="repair-items-table__head">
        <span>Тип</span>
        <span>Название</span>
        <span>Кол-во</span>
        <span>Ед.</span>
        <span>Цена</span>
        <span>Сумма</span>
        <span></span>
      </div>

      <FleetRepairItemForm
        v-for="(item, index) in items"
        :key="item.local_id"
        :item="item"
        :index="index"
        :item-type-options="itemTypeOptions"
        :vat-kind-options="vatKindOptions"
        :vat-calculation-type-options="vatCalculationTypeOptions"
        :errors="itemErrors(index)"
        :can-remove="items.length > 1"
        @update-field="$emit('update-item-field', $event)"
        @clear-error="handleClearItemError"
        @sync-amount="$emit('sync-item-amount', $event)"
        @remove="$emit('remove-item', $event)"
      />
    </div>

    <div class="repair-total">
      <div>
        <span>Без НДС</span>
        <strong>{{ formatMoney(baseAmount) }}</strong>
      </div>
      <div>
        <span>НДС</span>
        <strong>{{ formatMoney(vatAmount) }}</strong>
      </div>
      <div>
        <span>Работы</span>
        <strong>{{ formatMoney(laborAmount) }}</strong>
      </div>
      <div>
        <span>Запчасти и материалы</span>
        <strong>{{ formatMoney(partsAmount) }}</strong>
      </div>
      <div class="repair-total__main">
        <span>Итого</span>
        <strong>{{ formatMoney(totalAmount) }}</strong>
      </div>
    </div>
  </BaseFormSection>
</template>

<script>
import AppIcon from "@/components/Icon/AppIcon.vue";
import FleetRepairItemForm from "@/components/Fleet/Repair/ItemForm.vue";

export default {
  name: "FleetRepairItemsSection",

  components: {
    AppIcon,
    FleetRepairItemForm,
  },

  props: {
    baseAmount: { type: Number, required: true },
    formatMoney: { type: Function, required: true },
    itemErrors: { type: Function, required: true },
    itemTypeOptions: { type: Array, required: true },
    items: { type: Array, required: true },
    laborAmount: { type: Number, required: true },
    partsAmount: { type: Number, required: true },
    totalAmount: { type: Number, required: true },
    vatAmount: { type: Number, required: true },
    vatCalculationTypeOptions: { type: Array, required: true },
    vatKindOptions: { type: Array, required: true },
  },

  emits: [
    "add-item",
    "clear-item-error",
    "remove-item",
    "sync-item-amount",
    "update-item-field",
  ],

  methods: {
    handleClearItemError(index, field) {
      this.$emit("clear-item-error", index, field);
    },
  },
};
</script>

<style scoped>
.items-toolbar,
.repair-items-table,
.repair-total {
  grid-column: 1 / -1;
}

.items-toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: var(--base-in-indent);
  margin-bottom: var(--base-in-indent);
}

.repair-add-item-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.repair-add-item-button__icon {
  flex: 0 0 auto;
  width: 16px;
  height: 16px;
}

.repair-items-table {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.repair-items-table__head {
  display: grid;
  grid-template-columns: 150px minmax(220px, 1fr) 88px 82px 120px 120px 36px;
  gap: 10px;
  align-items: center;
  padding: 10px 12px;
  background: #f8fafc;
  border-bottom: 1px solid #e5e7eb;
  color: #6b7280;
  font-size: 12px;
  font-weight: 600;
}

.repair-total {
  display: flex;
  align-items: stretch;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: var(--base-in-indent);
}

.repair-total div {
  display: flex;
  min-width: 150px;
  flex-direction: column;
  gap: 4px;
  padding: 10px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
}

.repair-total span {
  color: #6b7280;
  font-size: 12px;
}

.repair-total strong,
.repair-total__main strong {
  color: var(--color-dark);
}

.repair-total .repair-total__main {
  border-color: var(--color-green);
  background: #f0fdf4;
}

@media (max-width: 760px) {
  .items-toolbar {
    align-items: stretch;
  }

  .repair-items-table {
    border: none;
    background: transparent;
  }

  .repair-items-table__head {
    display: none;
  }

  .repair-total {
    align-items: stretch;
    flex-direction: column;
  }
}
</style>
